import React, { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from "react-router-dom";

import backIcon from "assets/icons/backIcon.svg";
import menuIcon from "assets/icons/menuIcon.svg";
import backIconBlack from "assets/icons/back-icon-black.svg";
import logoutIcon from "assets/icons/logoutIcon.svg";
import { setShowLogout } from "../store/headerSlice";
import { logoutThunk } from "features/auth/presentation/store/authSlice";
import { STORAGE_KEYS } from "../../hooks/useAttendanceCheck";

const Header = () => {
    const { showBack, title, onBack, showBackBlack, showLogout, showMenu } = useSelector((state) => state.header);
    const { user } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const handleMenu = () => {
        navigate("/menu_manager", { replace: true });
    };

    const handleLogout = () => {
        const savedCheckoutTime = localStorage.getItem(STORAGE_KEYS.CHECKOUT_TIME);
        if (savedCheckoutTime) {
            dispatch(logoutThunk({
                id: user?.userId.trim(),
                parkingId: user?.parkingId.trim(),
            }));
        }else{
            navigate("/time_attendance");
        }
    }

    useEffect(() => {
        if (location.pathname === '/menu_manager') {
            dispatch(setShowLogout(true));
        } else {
            dispatch(setShowLogout(false));
        }
    }, [location, dispatch]);

    useEffect(() => {
        if (!user?.success) {
            navigate("/", { replace: true });
        }
    }, [user, navigate]);


    return (
        <header className={`app-header ${showBackBlack ? 'mn-white-header' : ''}`}>
            <div className="main-header">
                <div className="header-left">
                    {showBackBlack && (<img src={backIconBlack} alt="back" onClick={() => {
                        onBack ? onBack() : navigate(-1);
                    }} className="header-button back-button" />)}
                    {showBack && !showBackBlack && (<img src={backIcon} alt="back black" onClick={() => {
                        onBack ? onBack() : navigate(-1);
                    }} className="header-button back-button" />)}
                </div>
                <h1 className="header-title">{title}</h1>
                <div className="header-right">
                    {showBackBlack ? '' : (
                        showMenu && !showLogout && (
                        <button onClick={handleMenu}>
                            <img src={menuIcon} alt="menu" />
                        </button>
                        )
                    )}

                    {showBackBlack ? '' : (showLogout && <button onClick={handleLogout}>
                        <img className="htLogOut" src={logoutIcon} alt="menu" />
                    </button>)
                    }

                </div>

            </div>


        </header>


    );
};

export default Header;
